import { useCallback, useMemo } from 'react';
import { useService } from '../common';
import { SubmitSurveyRequest, Survey } from './types';
import type { ServiceResponse } from '../common/types';

const API = {
    SURVEY_SEARCH: '/survey/search',
    SURVEY_SUBMIT: '/survey/submit',
};

export const useSurveyService = () => {
    const service = useService();

    const searchSurveys = useCallback((): Promise<Survey[]> => {
        return service.sendGetWithAuthorization(API.SURVEY_SEARCH)
            .then(service.handleResponse)
            .catch(error => Promise.resolve(error));
    }, [service]);

    const submitSurvey = useCallback((request: SubmitSurveyRequest): ServiceResponse => {
        return service.sendPostWithAuthorization(API.SURVEY_SUBMIT, request)
            .then(service.handleResponse)
            .catch(error => Promise.resolve(error));
    }, [service]);

    return useMemo(() => ({
        searchSurveys,
        submitSurvey,
    }), [
        searchSurveys,
        submitSurvey,
    ]);
};